module.exports = __webpack_public_path__ + "h5/img/wx.5455db92.png";